import defaultItems from '../../../../../common/defaultItems';

export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Social links',
        thumbnailUrl: null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 20,
            paddingBottom: 30,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'SPACER',
                            content: {
                                ...defaultItems.SPACER.content,
                                height: 3,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                textMarkupValue: '<p><strong>#yourcompanyhashtag</strong></p>',
                                align: 'center',
                                paddingTop: 30,
                                fontSize: '18px',
                                lineHeight: '18px',
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'SOCIAL',
                            content: {
                                ...defaultItems.SOCIAL.content,
                                iconSize: 28,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                textMarkupValue:
                                    '<p>This is an internal email and not intended for external distribution. Please do not forward.</p>',
                                align: 'center',
                                fontSize: '12px',
                                paddingTop: 5,
                            },
                        },
                    ],
                },
            ],
        },
    };
}
